"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editorActions = void 0;
exports.editorActions = {
    /* MOB_USER */
    FETCH_MOB_USER: true,
    CREATE_MOB_USER: true,
    DELETE_MOB_USER: true,
    EDIT_MOB_USER: true, // Includes LICENSE_MOB_USER, UNLICENSE_MOB_USER, UNLOCK_LOGIN
    ADVANCED_ACTION_MOB_USER: false,
    /* WEB_USER */
    FETCH_WEB_USER: true,
    CREATE_WEB_USER: true,
    DELETE_WEB_USER: true,
    EDIT_WEB_USER: true,
    /* TEAM */
    FETCH_TEAM: true,
    CREATE_TEAM: true,
    // DELETE_TEAM: true,
    EDIT_TEAM: true, // Includes RESET_PASSWORD
    /* WORKFLOW */
    FETCH_WORKFLOW: true,
    /* ACTIVITY */
    FETCH_ACTIVITY: true,
    /* ALL REPORTS (WORKFLOWS, ACTIVITIES, ...) */
    FETCH_ACTIVITY_REPORT: true,
    CREATE_ACTIVITY_REPORT: true,
    DELETE_ACTIVITY_REPORT: true,
    /* LIST */
    FETCH_LIST: true,
    /* ITEM */
    FETCH_ITEM: true,
    CREATE_ITEM: true,
    DELETE_ITEM: true,
    EDIT_ITEM: true,
    /* TERRITORY */
    FETCH_TERRITORY: true,
    EDIT_TERRITORY: true,
    /* DASHBOARD */
    FETCH_DASHBOARD: true,
    VIEW_DEFAULT_DASHBOARDS: true,
    EXPORT_CLIENT_DATA: true,
    /* DOCUMENT */
    FETCH_DOCUMENT: true,
    FETCH_CALENDAR_EVENT: true,
    EDIT_CALENDAR_EVENT: true,
    CREATE_CALENDAR_EVENT: true,
    DELETE_CALENDAR_EVENT: true,
    FETCH_ORDER: true,
    EDIT_ORDER: true,
    DELETE_ORDER: true,
    CREATE_ORDER: true,
};
